function checkInputValidity(input, parent) {
	if (input[0].checkValidity()) {
		parent.removeClass("error");
		parent.addClass("success");
	} else {
		parent.removeClass("success");
		parent.addClass("error");
	}
}
$('input[type="text"],input[type="email"],input[type="phone"]').each(
	function () {
		var input = $(this);
		var inputId = $(this).attr("id");
		var parent = input.parent();
		var label = "";
		var placeHolder = "";

		// if there is no id setted up
		if (inputId == null) {
			inputId = input.attr("name");
		}

		// Check for label
		if (parent.find("label").length > 0) {
			label = parent.find("label");
		} else {
			if (input.attr("placeholder") && input.attr("placeholder").length > 0) {
				placeHolder = input.attr("placeholder");
			} else {
				placeHolder = "need a label/ placeholder 2";
			}
			parent.prepend(
				'<label for="' + inputId + '">' + placeHolder + "</label>"
			);
		}

		// removing placeholder
		input.attr("placeholder", "");

		// adding class 'active' on keyup
		input.on("keyup", function () {
			if (input.val().length > 0) {
				parent.addClass("active");
				checkInputValidity(input, parent);
			} else {
				if (input.is("not:focus")) {
					parent.removeClass("success");
					parent.removeClass("active");
				}
			}
		});

		// on focus
		input.on("focus", function () {
			parent.addClass("active");
		});

		// on blur
		input.on("blur", function () {
			if (input.val().length <= 0) {
				parent.removeClass("active");
				parent.removeClass("success");
				parent.removeClass("error");
			}
		});
	}
);
$("[data-vbg]").youtube_background();

$(document).ready(function () {
	if ($(".hero-block.subnav_right_hero").length) {
		$("#header").addClass("has_subnav");
	}

	if ($(".homepage__animation").length > 0) {
		var newTl = gsap.timeline();
		var tl = gsap.timeline({
			onComplete: () => {
				// $('.header--navigation').css({'transform':'translate(0,0)'})
				if ($("#typed-strings").length > 0) {
					var typed = new Typed("#typed", {
						stringsElement: "#typed-strings",
						typeSpeed: 30,
						backSpeed: 30,
						loop: true,
						loopCount: Infinity,
						backDelay: 3000,
					});
				}
				$(".hero__pause-video button").on("click", function () {
					var button = $(this);
					var buttonState = button.attr("aria-checked");
					if (buttonState == "true") {
						button.attr("aria-checked", false).change();
						typed.stop();
						$(".play-toggle").click();
					} else {
						button.attr("aria-checked", true).change();
						typed.start();
						$(".play-toggle").click();
					}
				});
				gsap.to("#typed", {
					duration: 0.5,
					// y: 100,
					opacity: 1,
					ease: "back",
				});
				gsap.to(".typed-cursor", {
					duration: 0.5,
					// y: 100,
					opacity: 1,
					ease: "back",
				});
			},
		});
		/*
		tl.to(".homepage__animation .layer_five", { duration: 1, yPercent: -100 })
			.from(
				".homepage__animation .layer_four #layer2",
				{ duration: 0.5, y: 5, ease: Back.easeOut.config(1), opacity: 0 },
				"<0.2"
			)
			.from(
				".homepage__animation .layer_four #layer3",
				{ duration: 0.5, y: 5, ease: Back.easeOut.config(1), opacity: 0 },
				"<0.2"
			)
			.from(
				".homepage__animation .layer_four #layer4",
				{ duration: 0.5, y: 5, ease: Back.easeOut.config(1), opacity: 0 },
				"<0.2"
			)
			.to(".homepage__animation .layer_four", {
				duration: 1,
				yPercent: -100,
				delay: 0.5,
			})
			.to(
				".homepage__animation .layer_three",
				{ duration: 0.8, yPercent: -100 },
				"<0.4"
			)
			.to(
				".homepage__animation .layer_two",
				{ duration: 0.5, yPercent: -100 },
				"< 0.3"
			)
			.to(
				".homepage__animation .layer_one",
				{ duration: 1, yPercent: -100, opacity: 0 },
				"<0.2"
			)
			.to(
				".homepage__animation ",
				{ duration: 0.5, yPercent: -100, opacity: 0, zIndex: -10 },
				"<0.5"
			)
			.from(
				"#header-inner > div ",
				{ duration: 1, stagger: 0.1, opacity: 0, ease: "back" },
				"<0.1"
			)
			.from(
				".hero-block__right-column .YT-background",
				{ duration: 1, opacity: 0, ease: "back" },
				"<-0.5"
			)
			.from(
				".hero-block__right-column",
				{ duration: 1, opacity: 0, ease: "back" },
				"<0.2"
			)
			.from(".hero-block__heading", { y: 100, opacity: 0, ease: "back" });*/
	}

/**
 * Start GTranslate custom JS -----------------------------------------------------------------
 */
	// Copy language options set in backend rendered through shortcode
	// to dropdown
	let languageMenu = $('.menu-item-language-switcher').find('.gtranslate');
	let optionsArray = [];

	// Wrap <a></a> elements
	$('.gtranslate_wrapper').find('a').wrap('<li class="menu-item"></li>');

	/*
	$('.gtranslate_wrapper').find('a').each(function(i, e) {
		let title = $(e).text().trim();
		//let onClickString = $(e).prop('onclick').toString();
		//let languageParam = onClickString.substr(40, 5).trim();
		let languageParam = $(e).data('gt-lang');
		let optionHtml = `<li class="menu-item"><a class="custom-lang-item" data-custom-lang-item="${languageParam}">${title}</a></li>`;
		let optionJSON = {
			'title': title,
			'html': optionHtml
		};
		optionsArray.push(optionJSON);
	});

	// Sort options alphabetically
	optionsArray.sort((a, b) => a.title.localeCompare(b.title));*/

	/*
	// Iterate over language options
	for (let n = 0; n < optionsArray.length; n++) {
		if (optionsArray[n].title == 'English') {
			languageMenu.prepend(optionsArray[n].html);
		} else {
			// any language other than "english"
			languageMenu.append(optionsArray[n].html);
		}
	}*/

	/**
	 * On page load set the correct language label
	 */
	setTimeout(function() {
		let currentLang = $('.gtranslate_wrapper').find('.gt-current-lang').data('gt-lang');
		set_lang_label(currentLang);
		set_client_portal_position(currentLang);
		set_main_nav_positon(currentLang);
	}, 1500);

	$('.gtranslate_wrapper').find('.menu-item a').on('click', function(ev) {
		let lang = $(this).data('gt-lang');
		set_lang_label(lang);
		set_client_portal_position(lang);
		set_main_nav_positon(lang);

		$(".gtranslate.sub-menu").toggleClass("active");

	})

	// GTranslate
	if (typeof doGTranslate === "function") {
		// Check if GTranslate is active
		$(".header--navigation .language").click(function () {
			$(".gtranslate.sub-menu").toggleClass("active");
		});
	}
});

/** Function to get current language  */
function gt_get_cookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function set_lang_label(lang) {
	// Change the label in the navigation to the new lang
	let langText;
	if ( lang == 'en' ) {
		langText = 'US-EN';
	} else if ( lang == 'nl' ) {
		langText = 'NL-NL';
	} else if ( lang == 'fr' ) {
		langText = 'CA-FR';
	} else if ( lang == 'de' ) {
		langText = 'GER-DE';
	} else if ( lang == 'es' ) {
		langText = 'SP-ES';
	}
	$('.menu-item-language-switcher').find('.language').text(langText);
}

function set_client_portal_position(lang) {
	// For english there's no overlap so no adjustment needed
	// For all other languages we need to move the client portal to the right
	if ( lang != 'en' ) {
		$('.header-portal').find('.client-portal').addClass('client-portal-pos');
	} else {
		$('.header-portal').find('.client-portal').removeClass('client-portal-pos');
	}
}

// Prevent overlap for navigation for certain languages on smaller screens
function set_main_nav_positon(lang) {
	if ( lang == 'de' || lang == 'fr' || lang == 'es' ) {
		// Move main nav a bit down
		$('.main-menu__list').addClass('translated-main-menu-pos');

		// Move logo a bit up
		$('.header-logo').addClass('translated-header-logo-pos');
	} else {
		$('.main-menu__list').removeClass('translated-main-menu-pos');
		$('.header-logo').removeClass('translated-header-logo-pos');
	}
}

/*
function checkCurrentLanguage() {
	var current_language = gt_get_cookie("googtrans").split("/").pop();
	$(".main-menu__list li").addClass("small-font"); // Add a class to have a small font size on main menu navigation

	if (current_language == "de") {
		$(".header--navigation .language").html("GER-DE");

	} else if (current_language == "fr") {
		$(".header--navigation .language").html("CA-FR");
	} else if (current_language == "es") {
		$(".header--navigation .language").html("SP-ES");
	} else if (current_language == "nl") {
		$(".header--navigation .language").html("NL-NL");
	} else {
		$(".header--navigation .language").html("US-EN");
		$(".main-menu__list li").removeClass("small-font"); // Remove the class to have a small font size on main menu navigation for English
	}
}*/

/**
 * END GTranslate custom JS -------------------------------------------------------
 */
